import React from 'react';
import Icon from 'components/Theme/images/GDC-App-data-portal-blue.svg';

const GDCDataPortalIcon = ({
  alt,
  style,
}: Object): React.Element => (
  <img
    alt={alt}
    className="icon icon-gdc-data-portal"
    src={Icon}
    style={style}
    />
);

export default GDCDataPortalIcon;
